<template>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.40039 17C5.95268 17 6.40039 17.4477 6.40039 18V31.2C6.40039 32.3046 7.29581 33.2 8.40039 33.2H27.6004C28.7049 33.2 29.6004 32.3046 29.6004 31.2V18C29.6004 17.4477 30.0481 17 30.6004 17C31.1527 17 31.6004 17.4477 31.6004 18V31.2C31.6004 33.4092 29.8095 35.2 27.6004 35.2H8.40039C6.19127 35.2 4.40039 33.4092 4.40039 31.2V18C4.40039 17.4477 4.84811 17 5.40039 17Z" fill="#C3CBD4"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5996 3.49998C18.244 3.23332 17.7551 3.23332 17.3996 3.49998L4.19961 13.4C3.75778 13.7314 3.13098 13.6418 2.79961 13.2C2.46824 12.7582 2.55778 12.1314 2.99961 11.8L16.1996 1.9C17.2662 1.09998 18.7329 1.09998 19.7996 1.9L32.9996 11.8C33.4414 12.1314 33.531 12.7582 33.1996 13.2C32.8682 13.6418 32.2414 13.7314 31.7996 13.4L18.5996 3.49998Z" fill="#C3CBD4"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0004 20C17.1168 20 16.4004 20.7163 16.4004 21.6C16.4004 22.4837 17.1168 23.2 18.0004 23.2C18.8841 23.2 19.6004 22.4837 19.6004 21.6C19.6004 20.7163 18.8841 20 18.0004 20ZM14.4004 21.6C14.4004 19.6118 16.0122 18 18.0004 18C19.9886 18 21.6004 19.6118 21.6004 21.6C21.6004 23.5882 19.9886 25.2 18.0004 25.2C16.0122 25.2 14.4004 23.5882 14.4004 21.6Z" fill="#C3CBD4"/>
    </svg>
</template>

<script>
export default {
    name: 'IconHomeBig',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
